module.exports = __webpack_public_path__ + "static/media/20210410_182431_226_IMG_0283.6f0726eb.jpg";